import React from "react";
import { useSettingsStore } from "../../store/settingsStore";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFab() {
    const { settings } = useSettingsStore();
    const number = (settings.whatsapp || "905327371306").replace(/[^0-9]/g, "");
    return (
        <a
            href={`https://wa.me/${number}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-fab"
            aria-label="WhatsApp"
            className="fixed bottom-6 right-6 z-40 group"
        >
            <span className="absolute inset-0 rounded-full bg-teal/30 animate-ping" />
            <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] hover:scale-105 shadow-xl text-white">
                <MessageCircle className="w-7 h-7" />
            </span>
        </a>
    );
}
